<template>
  <div
      class="video"
      @click="openVideo"
      @keydown.enter="openVideo"
      @keydown.space="openVideo"
      tabindex="0"
      role="button"
      :aria-label="'Apri video: ' + videoObj.attributes.title">
    <div class="video-thumbnail-container">
      <img :src="getVideoThumbnailUrl(videoObj) ? getVideoThumbnailUrl(videoObj) : defaultThumbnail"
           :alt="'Anteprima del video: ' + videoObj.attributes.title"
           class="thumbnail"/>
      <img class="play-icon" src="@/assets/play-videos-icon.svg" alt="" aria-hidden="true"/>
    </div>
    <div class="video-info">
      <h3>{{ videoObj.attributes.title }}</h3>
      <p> {{ videoObj.attributes.type }}</p>
    </div>
  </div>
</template>

<script>
import defaultThumbnail from '@/assets/default-video-thumbnail.webp';

export default {
  name: "VideoComponent",
  components: {},
  props: {
    videoObj: Object,
  },
  data() {
    return {
      defaultThumbnail,
    };
  },
  methods: {
    openVideo(event) {
      // Prevent default for keyboard events to avoid unexpected behavior
      if (event.type === 'keydown') {
        event.preventDefault();
      }

      // Emitting video ID instead of the whole video object
      this.$emit('open-popup', this.videoObj.id);
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },

    getVideoThumbnailUrl(video) {
      let thumbnailLink = '';
      if (video.attributes.thumbnail && video.attributes.thumbnail.data) {
        thumbnailLink = `${process.env.VUE_APP_BASE_BACK_URL}${video.attributes.thumbnail.data.attributes.url}`;
      }
      return thumbnailLink;
    },
  }
}
</script>

<style scoped>
.video {
  cursor: pointer;
  width: 31%;
  max-width: 550px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  position: relative;
  border-radius: 4px;
}

.video:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.video:focus {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  outline: 3px solid #013747;
  outline-offset: 3px;
}

.video-thumbnail-container {
  position: relative;
  margin: 0;
  padding: 0;
}

.thumbnail {
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
  display: block;
}

.video-info {
  background-color: #fff;
  padding: 1rem 1.5rem 1.5rem;
  text-align: left;
}

.video-info h3 {
  margin: 0.625rem 0 0.313rem;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: clamp(16px, 2.5vw, 20px);
  color: #013747;
  letter-spacing: -0.4px;
  line-height: 1.2;
  width: 100%;
}

.video-info p {
  margin: 1rem 0 0;
  font-size: clamp(10px, 1.5vw, 11px);
  color: #013747;
  letter-spacing: 1px;
  text-transform: uppercase;  
}

.play-icon {
  position: absolute;
  right: 4%;
  bottom: 5%;
  width: clamp(20px, 3vw, 25px);
  height: auto;
  pointer-events: none;
}

/* Extra large screens */
@media (min-width: 1400px) {
  .video {
    width: 30%;
  }

  .video-info {
    padding: 1.25rem 2rem 2rem;
  }
}

/* Large screens */
@media (max-width: 1199px) {
  .video {
    width: 32%;
  }
}

/* Medium screens */
@media (max-width: 992px) {
  .video {
    width: 47%;
  }

  .play-icon {
    display: none;
  }

  .video-info {
    padding: 1rem 1.5rem;
  }

  .video-info h3 {
    font-size: clamp(14px, 2.5vw, 18px);
  }

  .video-info p {
    font-size: clamp(9px, 1.5vw, 12px);
    margin-top: 0.75rem;
  }
}

/* Small screens */
@media (max-width: 768px) {
  .video {
    width: 98%;
    margin: 0 auto 1rem;
  }

  .video-info {
    padding: 0.75rem 1.25rem;
  }

  .video-info h3 {
    font-size: clamp(16px, 3vw, 20px);
  }

  .video-info p {
    font-size: clamp(10px, 2vw, 12px);
  }
}

/* Extra small screens */
@media (max-width: 480px) {
  .video {
    width: 100%;
  }

  .video-info {
    padding: 0.625rem 1rem;
  }

  .video-info h3 {
    font-size: clamp(14px, 3.5vw, 18px);
    -webkit-line-clamp: 2;
  }

  .video-info p {
    font-size: clamp(9px, 2.5vw, 11px);
    margin-top: 0.5rem;
  }
}
</style>